import { ReactNode } from "react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"

export type BorrowReviewBoxProps = {
  children: ReactNode
  backgroundColor?: string
}

export default function BorrowReviewBox({
  children,
  backgroundColor,
}: BorrowReviewBoxProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        borderRadius: theme.borders.radius400,
        paddingTop: theme.sizing.scale100,
        paddingBottom: theme.sizing.scale100,
        display: "flex",
        flexDirection: "column",
        background: backgroundColor ?? theme.colors.backgroundSecondary,
      })}
    >
      {children}
    </Block>
  )
}
